import { useContext } from "react";
import { PatientContext } from "@/contexts/PatientContext";

export function usePatient() {
	const value = useContext(PatientContext);

	return value;
}
